/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_SettingsInputs */



/**
* | output |
* | --- |
* | "Import Settings" |
*
* @param {Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_settings = /** @type {((inputs?: Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importeinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग आयात करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de importação")
	return /** @type {LocalizedString} */ ("Import Settings")
});